module.exports = __webpack_public_path__ + "static/media/deleat.6aeedd82.svg";